import { Select, SelectOption, lucideIcons } from '@round/creatorbase-ui';
import styles from './TableSortingSelect.module.css';

const { ArrowDownWideNarrow } = lucideIcons;

type Props<TSortingKey extends string> = {
    options: SelectOption<TSortingKey>[];
    value: TSortingKey;
    onChange: (value: TSortingKey) => void;
};

const renderValue = <TSortingKey extends string>(
    options: SelectOption<TSortingKey>[],
    value: TSortingKey | undefined
) => {
    return (
        <div className={styles.sortingValue}>
            <ArrowDownWideNarrow className={styles.sortingValueIcon} />
            <span>{options.find((option) => option.value === value)?.label}</span>
        </div>
    );
};

const TableSortingSelect = <TSortingKey extends string>({ options, value, onChange }: Props<TSortingKey>) => {
    return (
        <Select
            contentClassName={styles.sortingContent}
            position="popper"
            options={options}
            value={value}
            onChange={(value) => {
                if (!value) {
                    return;
                }

                onChange(value);
            }}
            renderValue={(_props, value) => renderValue(options, value.value)}
        />
    );
};

export default TableSortingSelect;
